<template>
  <v-container fluid :class="$style['container']">
    <ToolBar>
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
      </template>
      <template v-slot:right>
      </template>
    </ToolBar>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <div :class="$style['main-content']">
          <div :class="$style['content-link']">
            <a @click="onMove('/mng/customers')">登録ユーザー一覧</a>
          </div>
          <div :class="$style['content-link']">
            <a @click="onMove('/mng/orders')">受注(見積)一覧</a>
          </div>
        </div>
      </v-content>
    </div>
  </v-container>
</template>

<script>
import AppNavigation from "@/components/app/navigation";
import ToolBar from "@/components/app/toolbar";
import Breadcrumb from "@/components/app/breadcrumb";

export default {
  components: {
    AppNavigation,
    ToolBar,
    Breadcrumb
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "メニュー",
          disabled: true
        }
      ];
    }
  },
  methods: {
    onMove(path) {
      this.$router.push({ path: path });
    }
  }
};
</script>

<style module lang="scss">
$base-app-header-height: 70px;
$base-index-header-height: 50px;
$base-index-footer-height: 60px;

.container {
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;

  .container-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: calc(100% - #{$base-app-header-height});

    .main-content {
      display: flex;
      position: relative;
      flex-direction: column;
      height: calc(
        100vh - #{$base-index-header-height} - #{$base-app-header-height}
      );

      .content-link {
        font-size: 20px;
        font-weight: 600;
        max-width: 600px;
        white-space: pre-wrap;
        margin: 20px 0px 0px 50px;
      }

      .content-link:hover {
        color: #f27f04;
        text-decoration: underline;
      }
    }
  }
}
</style>
